import React from 'react';
import { Switch, useHistory } from 'react-router-dom';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';

import { isUserAuthenticated } from '../helpers/authUtils';
import * as layoutConstants from '../constants/layout';
import { allFlattenRoutes as routes } from './index';
import Loader from '../components/Loader';
import { AxiosProvider } from '../helpers/AxiosContext';
import { AxiosApi } from '../helpers/AxiosApi';

// Lazy loading and code splitting -
// Derieved idea from https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const loading = () => <Loader />;

// All layouts/containers
const AuthLayout = Loadable({
    loader: () => import('../layouts/Auth'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const NoLeftSideBar = Loadable({
    loader: () => import('../layouts/NoLeftSideBar'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const VerticalLayout = Loadable({
    loader: () => import('../layouts/Vertical'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const HorizontalLayout = Loadable({
    loader: () => import('../layouts/Horizontal'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const DocLayout = Loadable({
    loader: () => import('../layouts/DocLayout'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const Routes = (props) => {
    // returns the layout
    const getLayout = () => {
        if (!isUserAuthenticated()) {
            const urlsNoNavbar = ['/documentation'];

            if(urlsNoNavbar.includes(window.location.pathname)) {
                return DocLayout;
            } 
            return AuthLayout;
        } 

        if (!['IU', 'SA'].includes(props.user?.role) || props.user?.role === undefined) {
            if (props.user?.account?.id === undefined) return NoLeftSideBar;
        }

        let layoutCls = VerticalLayout;

        switch (props.layout.layoutType) {
            case layoutConstants.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case layoutConstants.LAYOUT_DOCUMENTATION:
                layoutCls = DocLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };

    const Layout = getLayout();

    const history = useHistory();

    //create axios provider to use the history when redirecting
    const axios = new AxiosApi(history);

    let finalRoutes = [];
    const features = props.user?.features;
    if(features) {
        routes.forEach(route => {
            if (features.find(item => item.feature === route.feature)?.status !== false) {
                finalRoutes.push(route);
            }
        });
    } else {
        finalRoutes = routes;
    }
    
    // rendering the router with layout
    return (
        <AxiosProvider value={axios}>
            <Layout {...props}>
                <Switch>
                    {finalRoutes.map((route, index) => {
                        return !route.children ? (
                            <route.route
                                key={index}
                                path={route.path}
                                roles={route.roles}
                                exact={route.exact}
                                component={route.component}></route.route>
                        ) : null;
                    })}
                </Switch>
            </Layout>
        </AxiosProvider>
    );
}

const mapStateToProps = (state) => {
    return {
        layout: state.Layout,
        user: state.Auth.user,
    };
};

export default connect(mapStateToProps, null)(Routes);
